export const PAGES = { 0: "SIMULATION", 1: "POSTCODE ALLOCATION" };
